import { css } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import {
  Dialog,
  PopoverProps,
  PopoverRenderProps,
} from "react-aria-components";

import { PopoverContent } from "./PopoverContent";
import { _Popover } from "../_assets/_Popover";

interface Props extends PopoverProps {
  maxWidth?: string | number;
}

export function Popover(props: Props) {
  const { maxWidth, ...popoverProps } = props;

  const className = useMemo(
    () => css(styles.popover, props.maxWidth && { maxWidth: props.maxWidth }),
    [props.maxWidth]
  );

  return (
    <_Popover {...mergeProps(popoverProps, { className })} showArrow>
      {(renderProps: PopoverRenderProps) => {
        const children =
          typeof props.children === "function"
            ? props.children(renderProps)
            : props.children;

        return (
          <Dialog className={styles.dialog}>
            {typeof children === "string" ? (
              <PopoverContent>{children}</PopoverContent>
            ) : (
              children
            )}
          </Dialog>
        );
      }}
    </_Popover>
  );
}

const styles = {
  popover: css({
    maxWidth: "280px",
  }),
  dialog: css({
    outline: "none",
    "&[data-focus-visible]": {
      boxShadow: "var(--focus-action)",
    },
  }),
};
